<template>
  <StyledDiv
    :backgroundColor="styled('black')"
    flexDirection="row"
    justifyContent="space-between"
    class="navWrap"
  >
    <StyledDiv width="initial">
      <svg
        width="200px"
        height="100px"
        viewBox="0 0 266 88"
        version="1.1"
        class="svgClass"
      >
        <!-- Generator: Sketch 57.1 (83088) - https://sketch.com -->
        <title>Artboard</title>
        <desc>Created with Sketch.</desc>
        <g
          id="Artboard"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g
            id="LiteracyLoomLogo_FullColor_Vertical"
            transform="translate(1.000000, 0.000000)"
          >
            <path
              d="M31.24,31.5 L15.61,15.86"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M70.95,71.2 L55.31,55.57"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M55.31,31.5 L70.95,15.86"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M15.61,71.2 L31.24,55.57"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M0.58,55.66 L14.19,55.66"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M14.19,55.66 L5.99,63.86"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M31.23,86.35 L31.23,72.74"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M55.44,86.35 L55.44,72.74"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M72.47,55.66 L86.08,55.66"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M72.47,55.66 L80.67,63.86"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M31.23,14.32 L31.23,0.71"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M55.44,14.32 L55.44,0.71"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M0.58,31.45 L14.19,31.45"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M14.19,31.5 L5.99,23.29"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M72.47,31.45 L86.08,31.45"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M72.47,31.5 L80.67,23.29"
              id="Path"
              stroke="#B97AB4"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M20.61,43.41 L26.22,43.41"
              id="Path"
              stroke="#51B1E4"
              stroke-width="1.42"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M61.44,43.41 L67.06,43.41"
              id="Path"
              stroke="#51B1E4"
              stroke-width="1.42"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M43.33,25.86 L43.33,20.24"
              id="Path"
              stroke="#51B1E4"
              stroke-width="1.42"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M43.33,66.8 L43.33,61.18"
              id="Path"
              stroke="#51B1E4"
              stroke-width="1.42"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M31.23,14.32 L72.47,55.57"
              id="Path"
              stroke="#EFD215"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M55.44,14.32 L14.19,55.57"
              id="Path"
              stroke="#EFD215"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M55.44,72.74 L14.19,31.5"
              id="Path"
              stroke="#EFD215"
              stroke-width="1.42"
            ></path>
            <path
              d="M31.23,72.74 L72.47,31.5"
              id="Path"
              stroke="#EFD215"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M31.25,14.32 L31.25,72.74"
              id="Path"
              stroke="#EFD215"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M55.46,14.32 L55.46,72.74"
              id="Path"
              stroke="#EFD215"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M14.19,31.5 L72.47,31.5"
              id="Path"
              stroke="#EFD215"
              stroke-width="1.42"
              stroke-linecap="round"
            ></path>
            <path
              d="M14.19,55.57 L72.47,55.57"
              id="Path"
              stroke="#EFD215"
              stroke-width="1.42"
            ></path>
            <circle
              id="Oval"
              fill="#51B1E4"
              fill-rule="nonzero"
              cx="43.33"
              cy="26.4"
              r="2.1"
            ></circle>
            <circle
              id="Oval"
              fill="#51B1E4"
              fill-rule="nonzero"
              cx="60.49"
              cy="43.55"
              r="1.99"
            ></circle>
            <circle
              id="Oval"
              fill="#51B1E4"
              fill-rule="nonzero"
              cx="26.22"
              cy="43.55"
              r="1.99"
            ></circle>
            <circle
              id="Oval"
              fill="#51B1E4"
              fill-rule="nonzero"
              cx="43.33"
              cy="60.67"
              r="1.97"
            ></circle>
            <polygon
              id="Path"
              stroke="#51B1E4"
              stroke-width="1.42"
              stroke-linecap="round"
              stroke-linejoin="round"
              points="73.09 37.03 66.71 43.41 73.09 49.8 83.54 49.8 77.22 43.41 83.54 37.03"
            ></polygon>
            <polygon
              id="Path"
              stroke="#51B1E4"
              stroke-width="1.42"
              stroke-linecap="round"
              stroke-linejoin="round"
              points="14.22 37.03 20.61 43.41 14.22 49.8 3.77 49.8 10.09 43.41 3.77 37.03"
            ></polygon>
            <polygon
              id="Path"
              stroke="#51B1E4"
              stroke-width="1.42"
              stroke-linecap="round"
              stroke-linejoin="round"
              points="36.95 13.98 43.33 20.36 49.71 13.98 49.71 3.53 43.33 9.85 36.95 3.53"
            ></polygon>
            <polygon
              id="Path"
              stroke="#51B1E4"
              stroke-width="1.42"
              stroke-linecap="round"
              stroke-linejoin="round"
              points="36.95 72.85 43.33 66.47 49.71 72.85 49.71 83.3 43.33 76.98 36.95 83.3"
            ></polygon>
            <g
              id="Group"
              transform="translate(111.000000, 20.000000)"
              fill="#51B1E4"
              fill-rule="nonzero"
            >
              <polygon
                id="Path"
                points="0 18.4118111 0 0.271811105 4 0.271811105 4 14.7918111 13.04 14.7918111 13.04 18.4118111"
              ></polygon>
              <polygon
                id="Path"
                points="19.32 18.4118111 19.32 0.271811105 23.32 0.271811105 23.32 18.4118111"
              ></polygon>
              <polygon
                id="Path"
                points="39.16 3.9518111 39.16 18.4118111 35.16 18.4118111 35.16 3.9518111 29.64 3.9518111 29.64 0.271811105 44.68 0.271811105 44.68 3.9518111"
              ></polygon>
              <polygon
                id="Path"
                points="50.86 18.4118111 50.86 0.271811105 64.54 0.271811105 64.54 3.8318111 54.82 3.8318111 54.82 7.5118111 63.36 7.5118111 63.36 11.0518111 54.82 11.0518111 54.82 14.8718111 64.66 14.8718111 64.66 18.4118111"
              ></polygon>
              <path
                d="M82.32,18.4118111 L78.44,12.6118111 L75.3,12.6118111 L75.3,18.4118111 L71.3,18.4118111 L71.3,0.271811105 L79.58,0.271811105 C83.86,0.271811105 86.42,2.5318111 86.42,6.2718111 L86.42,6.2718111 C86.5367245,8.80425576 84.9494189,11.1033943 82.54,11.8918111 L86.98,18.3718111 L82.32,18.4118111 Z M82.32,6.4118111 C82.32,4.6918111 81.14,3.8118111 79.2,3.8118111 L75.2,3.8118111 L75.2,9.0318111 L79.2,9.0318111 C81.2,9.0318111 82.26,7.9918111 82.26,6.4518111 L82.32,6.4118111 Z"
                id="Shape"
              ></path>
              <path
                d="M106.66,18.4118111 L105,14.4118111 L97.32,14.4118111 L95.66,18.4118111 L91.66,18.4118111 L99.44,0.151811105 L103.16,0.151811105 L110.92,18.4118111 L106.66,18.4118111 Z M101.16,4.9318111 L98.76,10.8118111 L103.58,10.8118111 L101.16,4.9318111 Z"
                id="Shape"
              ></path>
              <path
                d="M124.06,18.7318111 C121.574918,18.770283 119.18088,17.7972883 117.427227,16.0360925 C115.673574,14.2748966 114.710863,11.8767047 114.76,9.3918111 L114.76,9.3918111 C114.715485,6.87672304 115.700523,4.45264544 117.486774,2.68149997 C119.273025,0.910354496 121.705381,-0.0540617325 124.22,0.0118111045 C126.891534,-0.122722159 129.49209,0.897103742 131.36,2.8118111 L128.82,5.7318111 C127.597329,4.49168808 125.940975,3.77465157 124.2,3.7318111 C122.747862,3.7624952 121.369826,4.37902383 120.379187,5.44122984 C119.388548,6.50343584 118.869483,7.92106151 118.94,9.3718111 L118.94,9.3718111 C118.852647,10.8326447 119.364165,12.2660272 120.356633,13.3415148 C121.3491,14.4170024 122.736865,15.0417786 124.2,15.0718111 C126.014878,15.0498902 127.739025,14.2747485 128.96,12.9318111 L131.5,15.5118111 C129.641144,17.6640222 126.90138,18.8497803 124.06,18.7318111 L124.06,18.7318111 Z"
                id="Path"
              ></path>
              <polygon
                id="Path"
                points="146.62 11.1918111 146.62 18.4118111 142.62 18.4118111 142.62 11.2518111 135.64 0.271811105 140.3 0.271811105 144.64 7.5518111 149.04 0.271811105 153.58 0.271811105"
              ></polygon>
            </g>
            <g
              id="Group-2"
              transform="translate(111.000000, 48.000000)"
              fill="#B97AB4"
              fill-rule="nonzero"
            >
              <polygon
                id="Path"
                points="0 18.66 0 0.52 4 0.52 4 15.04 13.1 15.04 13.1 18.66"
              ></polygon>
              <path
                d="M26.92,18.98 C24.3915642,19.0670818 21.9367724,18.1203148 20.1216173,16.3579916 C18.3064622,14.5956685 17.2876194,12.1699046 17.2998885,9.64 L17.2998885,9.64 C17.2987003,7.09940784 18.328022,4.66695266 20.1525422,2.89897749 C21.9770625,1.13100232 24.4407072,0.178744044 26.98,0.26 C29.5031304,0.172913317 31.9528375,1.11757085 33.7642434,2.87614411 C35.5756494,4.63471736 36.5923845,7.05539747 36.5801118,9.58 L36.5801118,9.58 C36.5865492,12.1204804 35.5623395,14.554967 33.7416072,16.3266942 C31.9208748,18.0984213 29.4593565,19.0558439 26.92,18.98 Z M32.42,9.6 C32.4743281,8.10697433 31.918939,6.65608899 30.8815419,5.58096834 C29.8441448,4.50584769 28.4140135,3.89901188 26.92,3.89994468 C25.4401166,3.89331888 24.0218586,4.49205635 22.9944687,5.55721799 C21.9670787,6.62237963 21.4199152,8.06132179 21.48,9.54 L21.48,9.54 C21.4313323,11.0314627 21.98859,12.4790881 23.0247669,13.5529442 C24.0609438,14.6268003 25.4877506,15.2353871 26.98,15.2400018 C28.4617167,15.2412122 29.8798164,14.6379706 30.9065812,13.5696822 C31.9333459,12.5013939 32.4799229,11.060505 32.42,9.58 L32.42,9.6 Z"
                id="Shape"
              ></path>
              <path
                d="M52.04,18.98 C49.514971,19.0615244 47.0654313,18.1122888 45.2546836,16.3505822 C43.4439359,14.5888756 42.4278183,12.1663153 42.4398917,9.64 L42.4398917,9.64 C42.4398917,4.31597501 46.755975,0 52.08,0 C57.404025,0 61.72,4.31597501 61.72,9.64 L61.72,9.64 C61.7049636,12.1718904 60.6691705,14.5906534 58.847109,16.3487168 C57.0250476,18.1067803 54.5708102,19.055464 52.04,18.98 L52.04,18.98 Z M57.54,9.6 C57.5943281,8.10697433 57.038939,6.65608899 56.0015419,5.58096834 C54.9641448,4.50584769 53.5340135,3.89901188 52.04,3.89994468 C50.5601166,3.89331888 49.1418586,4.49205635 48.1144687,5.55721799 C47.0870787,6.62237963 46.5399152,8.06132179 46.6,9.54 L46.6,9.54 C46.5513323,11.0314627 47.10859,12.4790881 48.1447669,13.5529442 C49.1809438,14.6268003 50.6077506,15.2353871 52.1,15.2400592 C53.5835071,15.2469301 55.0050137,14.645471 56.03303,13.5758804 C57.0610463,12.5062899 57.6057073,11.0620675 57.54,9.58 L57.54,9.6 Z"
                id="Shape"
              ></path>
              <polygon
                id="Path"
                points="82.54 18.66 82.54 6.82 77.44 14.56 77.44 14.56 72.38 6.9 72.38 18.66 68.38 18.66 68.38 0.52 72.68 0.52 77.46 8.2 82.22 0.52 86.52 0.52 86.52 18.66"
              ></polygon>
            </g>
          </g>
        </g>
      </svg>
    </StyledDiv>
    <StyledDiv
      class="menuOptions"
      width="initial"
      flexDirection="row"
      justifyContent="flex-end"
    >
      <StyledDiv
        hoverBrightness="brightness(90%)"
        cursor="pointer"
        height="50px"
        width="initial"
        class="singleOption"
        margin="0 5px"
      >
        <router-link class="routerLink" to="/">Home</router-link>
      </StyledDiv>
      <StyledDiv
        width="1px"
        height="30px"
        :backgroundColor="styled('white')"
        class="divider"
      />
      <StyledDiv
        hoverBrightness="brightness(90%)"
        cursor="pointer"
        height="50px"
        width="initial"
        class="singleOption"
        margin="0 5px"
      >
        <router-link class="routerLink" to="/about">About Us</router-link>
      </StyledDiv>
      <StyledDiv
        width="1px"
        height="30px"
        :backgroundColor="styled('white')"
        class="divider"
      />
      <StyledDiv
        hoverBrightness="brightness(90%)"
        cursor="pointer"
        height="50px"
        width="initial"
        class="singleOption"
        margin="0 5px"
      >
        <router-link class="routerLink" to="/science"
          >Science of Reading</router-link
        >
      </StyledDiv>
      <StyledDiv
        width="1px"
        height="30px"
        :backgroundColor="styled('white')"
        class="divider"
      />
      <StyledDiv
        hoverBrightness="brightness(90%)"
        cursor="pointer"
        height="50px"
        width="initial"
        class="singleOption"
        margin="0 5px"
      >
        <a href="http://LiteracyLoom.com/LiteracyLoomFlyerV13.pdf" class="routerLink"
          >Flyer</a
        >
      </StyledDiv>
    </StyledDiv>
  </StyledDiv>
</template>

<script>
import { StyledDiv } from "./styled";
import StyleCompiler from "./styled/StyleCompiler";

export default {
  components: { StyledDiv },
  methods: {
    styled(e) {
      return StyleCompiler(e);
    }
  }
};
</script>

<style scoped>
.routerLink {
  color: white;
  text-decoration: none;
  cursor: pointer;
  font-family: "Gotham-Book";
}
@media (max-width: 500px) {
  .navWrap {
    justify-content: center;
    width: 100vw;
  }
  .menuOptions {
    flex-direction: column;
    height: 100%;
    justify-content: center;
    padding: 0 5px;
  }
  .singleOption {
    height: initial;
    margin: 3px 0;
    font-family: "Gotham-Book";
  }
  .svgClass {
    margin: 0 5px;
    height: 100px;
    width: 150px;
  }
  .divider {
    width: 80%;
    height: 1px;
  }
}
@media (max-width: 340px) {
  .routerLink {
    font-size: 14px;
  }
}
</style>
